import React from 'react'
import { get } from 'lodash'
import { CloseIcon } from "~/assets/svg";
import './styles.css'



class SplashPage extends React.Component {
  constructor(){
    super()
    this.state={
      close: false
    }
  }
  render(){
    if(this.state.close){
      return(<div></div>)
    } else {
      return <div className="splash-screen">
        <a className="link desktop" href={get(this.props.data, "metadataMap.clickThroughURL")}>
          <div className="image" style={{ backgroundImage: `url(${get(this.props.data, "metadataMap.desktopImageURL")})` }}>
            <div className="close-icon" onClick={e => this.close(e)}>
              <CloseIcon />
            </div>
          </div>
        </a>
        <a className="link mobile" href={get(this.props.data, "metadataMap.clickThroughURL")}>
          <div className="image" style={{ backgroundImage: `url(${get(this.props.data, "metadataMap.mobileImageURL")})` }}>
            <div className="close-icon" onClick={e => this.close(e)}>
              <CloseIcon />
            </div>
          </div>
        </a>
      </div>;
    }
  }
  close(e){
    e.preventDefault()
    this.setState({close: !this.state.close})
  }
}
export default SplashPage;